import React, { PropsWithChildren } from "react"
import ReactDOM from "react-dom"

interface PortalProps {
  domElementId: string
}

const Portal: React.FC<PropsWithChildren<PortalProps>> = React.memo(
  ({ domElementId, children }) => {
    if (typeof document === "undefined") {
      return null
    }

    let root = document.querySelector(`#${domElementId}`)

    if (!root) {
      root = document?.createElement("div")
      root?.setAttribute("id", domElementId)
      document?.querySelector("body")?.appendChild(root)
    }

    if (!root) return null

    return ReactDOM.createPortal(<>{children}</>, root)
  }
)

export { Portal }
